import { get } from "svelte/store";
import { resetCampaignUserPhase as resetCampaignUserPhaseRemote } from "../../apiLoader/campaign";
import { updateCampaignUser } from "../../stores/campaignUser";
import { getCurrentPhase, getCurrentPhaseKey } from "../../utils";
import { sessionStore } from "../../stores/session";
import { getCampaignUser } from "../campaignUserManager";

export const resetCampaignUserPhase = async (): Promise<void> => {
  if (get(sessionStore).socialGiftingMode !== "full") {
    const campaignUser = await getCampaignUser();
    const currentPhase = getCurrentPhase(campaignUser.metadata);
    const currentPhaseKey = getCurrentPhaseKey(campaignUser.metadata);

    if (currentPhase?.startsWith("complete-order")) {
      await resetCampaignUserPhaseRemote();
      campaignUser.metadata[currentPhaseKey] = "rollback-phase";
      updateCampaignUser(campaignUser);
    } else {
      console.log("Skipping resetCampaignUserPhase because current phase is not complete-order");
    }
  } else {
    console.log("Skipping resetCampaignUserPhase because social gifting mode is full");
  }
};
